import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';

const API = process.env.REACT_APP_API_URL;

// crm limpio: normaliza el idvendedor_crm de localStorage ('' si no aplica).
function crmLimpio() {
  const crm = localStorage.getItem('idvendedor_crm');
  return crm && crm !== 'undefined' && crm !== 'null' ? crm : '';
}

// verTodo: superadmin (o el 9 legacy) ve TODOS los vendedores, SALVO que tenga
// idvendedor_crm asignado (en cuyo caso ve solo ese vendedor).
function calcVerTodo() {
  const idVend = localStorage.getItem('id_vendedor');
  const rol = localStorage.getItem('rol') || '';
  return (rol === 'superadmin' || String(idVend) === '9') && !crmLimpio();
}

// id efectivo: en ver-todo se manda '9' (id numerico valido que exige la lambda);
// si no, el CRM asignado o el propio vendedor.
function calcIdEfectivo() {
  const idVend = localStorage.getItem('id_vendedor');
  return calcVerTodo() ? '9' : (crmLimpio() || idVend);
}

// Estilos de badge por id_estatus (verde aplicada 5/7, amarillo pendiente 3, rojo fallida 2).
function badgeEstatus(e) {
  if (e === 5 || e === 7) return { background: '#dcfce7', color: '#166534' };
  if (e === 3) return { background: '#fef3c7', color: '#92400e' };
  if (e === 2) return { background: '#fee2e2', color: '#991b1b' };
  return { background: '#e2e8f0', color: '#475569' };
}

// Color del texto de diagnostico: resalta los casos a revisar.
function colorDiagnostico(diag) {
  if (diag === 'Pagada, pendiente de aplicar') return '#b45309'; // ambar
  if (diag === 'Falló' || diag === 'Pago no completado por el cliente') return '#b91c1c'; // rojo
  return '#475569';
}

function horaDe(fecha) {
  if (!fecha) return '';
  // fecha llega como "YYYY-MM-DD HH:MM:SS"
  const partes = String(fecha).split(' ');
  return partes.length > 1 ? partes[1].slice(0, 5) : String(fecha);
}

// Opciones del selector de rango (dias) del panel.
const RANGOS = [
  { dias: 1, label: 'Hoy' },
  { dias: 3, label: 'Últimos 3 días' },
  { dias: 7, label: 'Últimos 7 días' },
  { dias: 15, label: 'Últimos 15 días' },
  { dias: 30, label: 'Últimos 30 días' },
];

export default function CrmMonitoreo() {
  const [ventas, setVentas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filtro, setFiltro] = useState('todas');
  const [dias, setDias] = useState(1);
  // esGlobal se fija al montar: decide si se muestra la columna Vendedor.
  const [esGlobal] = useState(() => calcVerTodo());

  useEffect(() => { load(dias); }, [dias]);

  const load = async (diasRango = dias) => {
    setLoading(true);
    const idEfectivo = calcIdEfectivo();
    try {
      const res = await fetch(`${API}/prod/crm_monitoreo`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action: 'dia', idvendedor: idEfectivo, ver_todo: calcVerTodo() ? '1' : '0', dias: diasRango }),
      });
      const data = await res.json();
      const body = typeof data.body === 'string' ? JSON.parse(data.body) : data.body || data;
      setVentas(Array.isArray(body) ? body : []);
    } catch (e) {
      console.error(e);
      toast.error('Error al cargar monitoreo');
      setVentas([]);
    } finally {
      setLoading(false);
    }
  };

  const refrescar = () => {
    load(dias);
    toast.info('Actualizando monitoreo…', { autoClose: 1500 });
  };

  const rangoLabel = (RANGOS.find(r => r.dias === dias) || RANGOS[0]).label;

  // Resumen (actividad de hoy, aplicadas, pendientes, fallidas).
  const total = ventas.length;
  const aplicadas = ventas.filter(v => v.id_estatus === 5 || v.id_estatus === 7).length;
  const pendientes = ventas.filter(v => v.id_estatus === 3).length;
  const fallidas = ventas.filter(v => v.id_estatus === 2).length;

  // Filtros en cliente (sin refetch).
  const ventasFiltradas = ventas.filter(v => {
    if (filtro === 'pendientes') return v.id_estatus === 3;
    if (filtro === 'fallidas') return v.id_estatus === 2;
    if (filtro === 'pagadas_sin_aplicar') return v.id_estatus === 3 && v.pago_clip === 'COMPLETED';
    return true;
  });

  if (loading) {
    return <div style={{ padding: 20, textAlign: 'center', color: '#9ca3af' }}>Cargando monitoreo…</div>;
  }

  const cardStyle = {
    flex: 1, minWidth: 120, background: '#fff', borderRadius: '14px',
    padding: '16px', border: '1px solid #e2e8f0', textAlign: 'center',
  };

  const filtros = [
    { key: 'todas', label: 'Todas' },
    { key: 'pendientes', label: 'Pendientes' },
    { key: 'fallidas', label: 'Fallidas' },
    { key: 'pagadas_sin_aplicar', label: 'Pagadas sin aplicar' },
  ];

  return (
    <div style={{ marginTop: '20px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '10px' }}>
        <div>
          <h2 style={{ margin: 0 }}>🔎 Monitoreo del día</h2>
          <div style={{ fontSize: '13px', color: '#6b7280', marginTop: '2px' }}>
            Rango: {rangoLabel}
          </div>
        </div>
        <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap' }}>
          <select
            value={dias}
            onChange={(e) => setDias(Number(e.target.value))}
            style={{
              padding: '10px 12px', borderRadius: '8px', border: '1px solid #e2e8f0',
              background: '#fff', color: '#1b2938', fontSize: '14px', fontWeight: '600',
              cursor: 'pointer',
            }}
          >
            {RANGOS.map(r => (
              <option key={r.dias} value={r.dias}>{r.label}</option>
            ))}
          </select>
          <button onClick={refrescar} style={{
            padding: '10px 16px', background: '#1b2938', color: '#fff',
            border: 'none', borderRadius: '8px', cursor: 'pointer',
            fontSize: '14px', fontWeight: '600',
          }}>
            🔄 Actualizar
          </button>
        </div>
      </div>

      <div style={{ background: '#eff6ff', borderRadius: '14px', padding: '12px 14px', margin: '14px 0', fontSize: '13px', color: '#1e40af', lineHeight: '1.5' }}>
        Vista de solo lectura de las recargas y activaciones ({rangoLabel.toLowerCase()}). Revisa si una venta pasó o por qué no pasó.
      </div>

      {/* Tarjetas resumen */}
      <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', marginBottom: '16px' }}>
        <div style={cardStyle}>
          <div style={{ fontSize: '24px', fontWeight: 700, color: '#1b2938' }}>{total}</div>
          <div style={{ fontSize: '12px', color: '#6b7280' }}>Actividad</div>
        </div>
        <div style={cardStyle}>
          <div style={{ fontSize: '24px', fontWeight: 700, color: '#166534' }}>{aplicadas}</div>
          <div style={{ fontSize: '12px', color: '#6b7280' }}>Aplicadas</div>
        </div>
        <div style={cardStyle}>
          <div style={{ fontSize: '24px', fontWeight: 700, color: '#92400e' }}>{pendientes}</div>
          <div style={{ fontSize: '12px', color: '#6b7280' }}>Pendientes</div>
        </div>
        <div style={cardStyle}>
          <div style={{ fontSize: '24px', fontWeight: 700, color: '#991b1b' }}>{fallidas}</div>
          <div style={{ fontSize: '12px', color: '#6b7280' }}>Fallidas</div>
        </div>
      </div>

      {/* Filtros rapidos */}
      <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginBottom: '16px' }}>
        {filtros.map(f => (
          <button key={f.key} onClick={() => setFiltro(f.key)} style={{
            padding: '8px 14px', borderRadius: '20px', cursor: 'pointer',
            fontSize: '13px', fontWeight: '600',
            border: filtro === f.key ? '1px solid #1b2938' : '1px solid #e2e8f0',
            background: filtro === f.key ? '#1b2938' : '#fff',
            color: filtro === f.key ? '#fff' : '#1b2938',
          }}>
            {f.label}
          </button>
        ))}
      </div>

      {/* Lista por venta */}
      {ventasFiltradas.length === 0 ? (
        <div style={{ padding: 30, textAlign: 'center', color: '#9ca3af' }}>
          No hay ventas para este filtro en el rango seleccionado.
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          {ventasFiltradas.map((v, i) => (
            <div key={`${v.tipo}-${v.folioventa}-${i}`} style={{
              background: '#fff', borderRadius: '12px', padding: '14px',
              border: '1px solid #e2e8f0',
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
                <span style={{ fontSize: '20px' }}>{v.tipo === 'Recarga' ? '📲' : '📱'}</span>
                <div style={{ flex: 1, minWidth: 140 }}>
                  <div style={{ fontWeight: 700, fontSize: 14, color: '#1b2938' }}>
                    {v.tipo} · #{v.folioventa}
                  </div>
                  <div style={{ fontSize: 12, color: '#6b7280' }}>
                    {v.msisdn} · {v.oferta_nombre || v.oferta} · {horaDe(v.fecha)}
                    {esGlobal && (
                      <> · 👤 {v.vendedor_nombre || v.idvendedor_app}</>
                    )}
                  </div>
                </div>
                <span style={{
                  padding: '4px 10px', borderRadius: '12px', fontSize: '12px', fontWeight: '700',
                  ...badgeEstatus(v.id_estatus),
                }}>
                  {v.estatus_label}
                </span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap', marginTop: '10px', fontSize: '13px' }}>
                <span style={{ color: v.pago_clip === 'COMPLETED' ? '#166534' : '#6b7280' }}>
                  {v.pago_clip === 'COMPLETED' ? '🟢 Pagado' : '⚪ Sin pago'} (Clip)
                </span>
                <span style={{ color: colorDiagnostico(v.diagnostico), fontWeight: '600' }}>
                  {v.diagnostico}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}

      <div style={{ height: 80 }} />
    </div>
  );
}
